import React from 'react';
import { numberWithCommas } from '../../AppUtil/AppUtil';
import Error from '../Home/Error';
import { ExclamationCircleFilled } from '@ant-design/icons';
import ReactTooltip from 'react-tooltip';

export default function UserBalanceHeader({
	user = '',
	balance = 0,
	classContainer = '',
	error = '',
	pending_balance = 0
}) {
	console.log(pending_balance);
	return (
		<div className={classContainer}>
			<h3 className="dashboard-welcome-header">
				Welcome, <span className="dashboard-welcome-user">{user}</span>
			</h3>
			<div className="dashboard-desktop">
				<div className="dashboard-welcome-balance">
					<p className="dashboard-welcome-text">₱{numberWithCommas(balance)}</p>
					<p className="dashboard-welcome-text">Available Balance</p>
				</div>

				{pending_balance > 0 && (
					<div className="dashboard-pending-balance">
						<p>
							₱{numberWithCommas(pending_balance)} <span className="pending">pending</span>
						</p>
						<ExclamationCircleFilled
							data-tip
							data-for="pending"
							id="pending"
							style={{ color: '#fff', fontSize: '16px', marginTop: '5px' }}
						/>
						<ReactTooltip
							aria-haspopup="true"
							className="pending-tooltip"
							anchorSelect="#my-anchor-element"
							overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
								const d = document.documentElement;
								left = Math.min(d.clientWidth - node.clientWidth, left);
								top = Math.min(d.clientHeight - node.clientHeight, top);
								left = Math.max(0, left);
								top = Math.max(0, top);
								return { top, left };
							}}
							effect="solid"
							place="top"
							id="pending"
							role="pending">
							Funds will be available after 24 hours or one &#40;1&#41; business day.
						</ReactTooltip>
					</div>
				)}
			</div>

			<Error error={error} />
		</div>
	);
}
